module.exports = __webpack_public_path__ + "img/round3x - 副本.e2338c11.png";